import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { IsSuperAdmin } from './IsSuperAdmin';

export const RestrictAccessSuperAdmin = () => {
  const location = useLocation();

  return IsSuperAdmin() ? <Outlet /> : <Navigate to="/not-allowed" state={{ from: location }} replace />;
};
